import { AuthorizationOutcome } from '@/services/organization-authorization-service'

export default function (next:any, store: any): void {
  const authOutcome = store.getters['auth/authorizationOutcome'] as AuthorizationOutcome
  if (authOutcome !== AuthorizationOutcome.valid) {
    next({ name: 'log in' })
  } else { next() }
}
